<ng-container
  *ngIf="
    (chatItem.type == chatTypes.CHAT ||
      chatItem.type == chatTypes.CANVAS_CHAT) &&
    chatItem.message?.length > 0
  "
>
  <div class="chat-item justify-content-end">
    <div class="user-info align-items-end">
      <div
        class="d-flex align-items-center justify-content-center gap-1 mb-1"
        *ngIf="
          chatItem.created_by?.user_email?.length > 0 &&
          userEmail !== chatItem.created_by?.user_email
        "
      >
        <span class="user-email">{{ chatItem.created_by?.user_email }} </span>
      </div>
      <div
        class="d-flex align-items-center justify-content-center gap-1 mb-1"
        *ngIf="chatItem.type == chatTypes.CANVAS_CHAT"
      >
        <img
          class="avatar"
          src="../../../../../assets/icons/svg/chat-prompt.svg"
          alt="User"
          height="20"
          width="20"
        />
        <span class="ft-semibold ft-italic ft-12 font-color-home"
          >Asked in canvas editor
        </span>
      </div>

      <div class="d-flex align-items-center justify-content-center">
        <div
          class="me-2 cursor-pointer"
          (click)="onRefreshClicked()"
          (keydown)="onRefreshClicked()"
          *ngIf="isLastConversation && chatItem.status == conStatus.IN_PROGRESS"
        >
          <img
            src="../../../assets/icons/svg/refresh.svg"
            height="20"
            width="20"
            alt="refresh"
            [ngClass]="{ rotating: isRefreshing }"
          />
        </div>
        <div class="text-send sending">
          {{ chatItem.message }}
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="chatItem.uploaded_files?.length > 0">
  <div class="file-outliner">
    <div
      class="files-grid-wrapper"
      [ngClass]="{
        'files-grid-wrapper-when-side-panel-opened':
          hubService.isContentEditorOpened
      }"
    >
      <div class="file-grid-item" *ngFor="let file of chatItem.uploaded_files">
        <img src="../../../../../assets/icons/svg/file.svg" alt="file" />

        <div class="file-name-overflow">
          <span
            class="text"
            [ngClass]="{ 'error-text': chatItem.status == 'error' }"
            >{{ file.name }}</span
          >
          <div class="banner-progress" *ngIf="file.isUploading">
            <mat-progress-bar
              class="progress-margin"
              [ngClass]="{
                'progress-error': chatItem.status == 'error'
              }"
              [mode]="file.isUploading ? 'indeterminate' : 'determinate'"
              [value]="100"
            ></mat-progress-bar>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container
  *ngIf="
    chatItem.responses?.length > 0 &&
    (chatItem.type == chatTypes.CHAT || chatItem.type == chatTypes.CANVAS_CHAT)
  "
>
  <div class="chat-item justify-content-start">
    <div class="message-box-reply">
      <div class="user-info">
        <ng-container
          *ngIf="currentResponseDocument.document_id; else normalChat"
        >
          <ng-container
            *ngIf="!currentResponseDocument.type; else chatDocumentTemplate"
          >
            <div class="outline-container">
              <ng-container
                *ngIf="currentResponseDocument.error; else noErrorLoading"
              >
                <p class="outline-text mb-0">
                  An error occurred while preparing the content. Please try
                  again later.
                </p>
                <div
                  class="d-flex flex-row align-items-center justify-content-start gap-2"
                >
                  <div class="outline-box">
                    <img
                      class="cursor-pointer"
                      src="../../../../../assets/icons/svg/info-circle-error.svg"
                      alt="Error"
                      height="20"
                      width="20"
                    />
                    <span class="outline-box-text">Error loading content</span>
                  </div>
                  <img
                    class="cursor-pointer"
                    src="../../../../../assets/icons/svg/restart-red.svg"
                    alt="Error"
                    height="20"
                    width="20"
                    (click)="refreshContent()"
                    (keydown)="refreshContent()"
                  />
                </div>
              </ng-container>
              <ng-template #noErrorLoading>
                <p class="outline-text mb-0">
                  Please hold on while we prepare the content for you. This
                  might take a moment, thank you for your patience.
                </p>
                <div
                  class="outline-box opacity-50"
                  (click)="onTemporaryOutlineClicked()"
                  (keydown)="onTemporaryOutlineClicked()"
                >
                  <mat-progress-spinner
                    [color]="'primary'"
                    [mode]="'indeterminate'"
                  >
                  </mat-progress-spinner>
                  <span class="outline-box-text"
                    >Generating content, please wait...</span
                  >
                </div>
              </ng-template>
              <div
                class="outline-text"
                *ngIf="convertedMessage"
                #contentDiv
                [innerHtml]="convertedMessage"
                [appCanvasAuthImage]="convertedMessage"
              ></div>

              <ng-container
                *ngTemplateOutlet="
                  chatActionTemplate;
                  context: {
                    chatItem: chatItem,
                    disabled:
                      currentResponseDocument.error ||
                      !currentResponseDocument.type,
                    actionType: 'document-actions'
                  }
                "
              >
              </ng-container>
            </div>
          </ng-container>

          <ng-template #chatDocumentTemplate>
            <ng-container
              *ngIf="
                currentResponseDocument.type == chatTypes.SCORECARD;
                else otherDocuemntTypes
              "
            >
              <div class="outline-container">
                <p class="outline-text mb-0">
                  Scorecard is ready! You can review the details.
                </p>

                <div
                  class="outline-box"
                  (click)="onOutlineClicked()"
                  (keydown)="onOutlineClicked()"
                >
                  <img
                    class="cursor-pointer"
                    src="../../../../../assets/icons/svg/chat-outline.svg"
                    alt="Right"
                    height="20"
                    width="24"
                  />
                  <span class="outline-box-text">{{
                    currentResponseDocumentVersion?.title
                  }}</span>
                </div>

                <div
                  class="scorecard"
                  [ngClass]="{
                    'd-block': hubService.isContentEditorOpened
                  }"
                >
                  <div
                    class="scorecard-value"
                    [ngClass]="{
                      'float-start me-2': hubService.isContentEditorOpened
                    }"
                  >
                    <div
                      class="circular-progress"
                      [ngClass]="
                        currentResponseDocumentVersion.scorecard_summary
                          ?.styleClass
                      "
                    >
                      <svg
                        viewBox="0 0 36 36"
                        class="circular-chart"
                        [ngClass]="
                          currentResponseDocumentVersion.scorecard_summary
                            ?.styleClass
                        "
                      >
                        <g transform="rotate(90 18 18)">
                          <path
                            class="circle-bg"
                            [ngClass]="
                              currentResponseDocumentVersion.scorecard_summary
                                ?.styleClass
                            "
                            opacity="0.2"
                            d="M18 2.0845
                         a 15.9155 15.9155 0 0 1 0 31.831
                         a 15.9155 15.9155 0 0 1 0 -31.831"
                          />
                          <path
                            class="circle"
                            [attr.stroke-dasharray]="
                              currentResponseDocumentVersion.scorecard_summary
                                ?.percentage + ', 100'
                            "
                            d="M18 2.0845
                         a 15.9155 15.9155 0 0 1 0 31.831
                         a 15.9155 15.9155 0 0 1 0 -31.831"
                          />
                        </g>

                        <text x="18" y="20" class="percentage">
                          {{
                            currentResponseDocumentVersion.scorecard_summary
                              ?.text
                          }}
                        </text>
                      </svg>
                    </div>
                  </div>
                  <div
                    class="scorecard-description"
                    [ngClass]="{
                      'd-block': hubService.isContentEditorOpened
                    }"
                  >
                    <div class="score-title">
                      Limited Evidence- Requires Manual Input
                    </div>
                    <div class="score-description">
                      {{
                        currentResponseDocumentVersion.scorecard_summary
                          ?.description
                      }}
                    </div>
                  </div>
                </div>

                <div
                  class="outline-text"
                  *ngIf="convertedMessage"
                  #contentDiv
                  [innerHtml]="convertedMessage"
                ></div>

                <ng-container
                  *ngTemplateOutlet="
                    chatActionTemplate;
                    context: {
                      chatItem: chatItem,
                      disabled: false,
                      actionType: 'document-actions'
                    }
                  "
                >
                </ng-container>
              </div>
            </ng-container>

            <ng-template #otherDocuemntTypes>
              <div class="outline-container">
                <ng-container *ngIf="chatItem.type != chatTypes.CANVAS_CHAT">
                  <p
                    class="outline-text mb-0"
                    *ngIf="currentResponseDocument.type == chatTypes.OUTLINE"
                  >
                    The Outline is ready! You can suggest changes, add more
                    sections, or let me know if you want to dive into specific
                    parts.
                  </p>
                  <p
                    class="outline-text mb-0"
                    *ngIf="
                      currentResponseDocument.type == chatTypes.SECTION ||
                      currentResponseDocument.type ==
                        chatTypes.PROJECT_NARRATIVE
                    "
                  >
                    Section is ready! You can suggest changes, add more
                    sections, or let me know if you want to dive into specific
                    parts.
                  </p>
                </ng-container>
                <ng-container
                  *ngIf="hubService.isContentEditorOpened; else partialView"
                >
                  <div
                    class="outline-box"
                    (click)="onOutlineClicked()"
                    (keydown)="onOutlineClicked()"
                  >
                    <img
                      class="cursor-pointer"
                      src="../../../../../assets/icons/svg/chat-outline.svg"
                      alt="Right"
                      height="20"
                      width="24"
                    />
                    <span class="outline-box-text">{{
                      currentResponseDocumentVersion?.title
                    }}</span>
                  </div>
                </ng-container>
                <ng-template #partialView>
                  <div class="outline-partial-view-box">
                    <div
                      class="outline-box-partial"
                      (click)="onOutlineClicked()"
                      (keydown)="onOutlineClicked()"
                    >
                      <div class="out-box">
                        <img
                          class="cursor-pointer"
                          src="../../../../../assets/icons/svg/chat-outline.svg"
                          alt="Right"
                          height="20"
                          width="24"
                        />
                        <span class="outline-box-text">{{
                          currentResponseDocumentVersion?.title
                        }}</span>
                      </div>
                      <img
                        class="cursor-pointer"
                        src="../../../../../assets/icons/svg/chat-expand.svg"
                        alt="Right"
                        height="25"
                        width="30"
                      />
                    </div>

                    <div
                      *ngIf="currentResponseDocumentVersion?.partialContent"
                      class="partial-container scrollbar-custom-scroll-style"
                      [innerHtml]="
                        currentResponseDocumentVersion.partialContent
                      "
                      [appCanvasAuthImage]="
                        currentResponseDocumentVersion.partialContent
                      "
                    ></div>
                  </div>
                </ng-template>
                <div
                  class="outline-text"
                  *ngIf="convertedMessage"
                  #contentDiv
                  [innerHtml]="convertedMessage"
                ></div>

                <ng-container
                  *ngTemplateOutlet="
                    chatActionTemplate;
                    context: {
                      chatItem: chatItem,
                      disabled: false,
                      actionType: 'document-actions'
                    }
                  "
                >
                </ng-container>
              </div>
            </ng-template>
          </ng-template>
        </ng-container>

        <ng-template #normalChat>
          <ng-container
            *ngIf="
              currentResponseItem?.convertedMessage?.length > 0 &&
              convertedMessage
            "
          >
            <div class="d-flex flex-column">
              <div
                #contentDiv
                class="text-reply"
                [innerHtml]="convertedMessage"
                [appCanvasAuthImage]="convertedMessage"
              ></div>

              <ng-container
                *ngTemplateOutlet="
                  chatActionTemplate;
                  context: {
                    chatItem: chatItem,
                    disabled: false,
                    actionType: 'chat-actions'
                  }
                "
              >
              </ng-container>
            </div>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </div>
</ng-container>

<ng-template
  #chatActionTemplate
  let-item="chatItem"
  let-disabled="disabled"
  let-actionType="actionType"
>
  <div class="d-flex justify-content-start align-items-center opacity-75">
    <div
      class="actions d-flex flex-row align-items-center justify-content-start"
      [ngClass]="{ disabled: disabled }"
    >
      <ng-container *ngIf="sourcesList?.length > 0">
        <div
          *ngIf="!hubService.isContentEditorOpened"
          class="source-box"
          (click)="onSourceClicked()"
          (keydown)="onSourceClicked()"
        >
          <div class="source-container">
            <span class="source-title ft-semibold">Citations</span>
          </div>
        </div>
      </ng-container>

      <div
        class="d-flex flex-row align-items-center justify-content-center"
        *ngIf="chatItem.responses?.length > 1"
      >
        <img
          class="cursor-pointer rotate-90"
          src="../../../assets/icons/svg/chevron-arrow-thick.svg"
          (click)="
            decrementIndex();
            getResponseItemHtml();
            getSources();
            updateCanvas()
          "
          alt="Left"
          height="38"
          (keydown)="
            decrementIndex();
            getResponseItemHtml();
            getSources();
            updateCanvas()
          "
          [width]="hubService.isContentEditorOpened ? 20 : 30"
        />
        <span class="ft-16 ft-semibold counter-navigation">{{
          getIndexLengthString()
        }}</span>
        <img
          class="cursor-pointer rotate--90"
          src="../../../assets/icons/svg/chevron-arrow-thick.svg"
          alt="Right"
          (click)="
            incrementIndex();
            getResponseItemHtml();
            getSources();
            updateCanvas()
          "
          (keydown)="
            incrementIndex();
            getResponseItemHtml();
            getSources();
            updateCanvas()
          "
          height="38"
          [width]="hubService.isContentEditorOpened ? 20 : 30"
        />
      </div>
      <ng-container
        *ngIf="sourcesList?.length > 0 && hubService.isContentEditorOpened"
      >
        <img
          class="chat-action-icon"
          src="../../../assets/icons/svg/chat-info.svg"
          alt="Citations"
          height="18"
          width="18"
          matTooltipPosition="above"
          [matTooltipClass]="['header-saved-search-item-theme']"
          matTooltip="Citations"
          (click)="onSourceClicked()"
          (keydown)="onSourceClicked()"
        />
      </ng-container>

      <img
        class="chat-action-icon"
        src="../../../assets/icons/svg/copy-message-blue.svg"
        alt="Copy"
        height="20"
        width="20"
        matTooltipPosition="above"
        [matTooltipClass]="['header-saved-search-item-theme']"
        matTooltip="Copy message"
        (click)="copyResponse()"
        (keydown)="copyResponse()"
      />

      <img
        *ngIf="
          isLastConversation &&
          chatItem.type != chatTypes.CANVAS_CHAT &&
          !hubService.isSessionReadOnly
        "
        class="chat-action-icon"
        [ngClass]="{
          'regenerating-rotate': hubService.isAgentRegenerating(
            chatItem._id,
            chatItem.session_id
          ),
          disabled: hubService.isAgentWorking()
        }"
        src="../../../assets/icons/svg/refresh-chat-blue.svg"
        alt="Regenerate"
        height="22"
        width="22"
        (click)="hubService.regenerateChatResponse(chatItem)"
        (keydown)="hubService.regenerateChatResponse(chatItem)"
        matTooltipPosition="above"
        [matTooltipClass]="['header-saved-search-item-theme']"
        [matTooltip]="
          hubService.isAgentRegenerating(chatItem._id, chatItem.session_id)
            ? 'Regenerating...'
            : 'Regenerate response'
        "
      />

      <img
        *ngIf="!hubService.isSessionReadOnly"
        class="chat-action-icon"
        [src]="
          chatItem.bookmarked
            ? '../../../assets/icons/svg/bookmark-on.svg'
            : '../../../assets/icons/svg/bookmark-off.svg'
        "
        alt="Bookmark"
        height="18"
        width="18"
        matTooltipPosition="above"
        [matTooltipClass]="['header-saved-search-item-theme']"
        [matTooltip]="chatItem.bookmarked ? 'Remove bookmark' : 'Bookmark'"
        (click)="
          hubService.bookmarkResponse(
            chatItem,
            chatItem.bookmarked ? 'remove' : 'add'
          )
        "
        (keydown)="
          hubService.bookmarkResponse(
            chatItem,
            chatItem.bookmarked ? 'remove' : 'add'
          )
        "
      />

      <img
        *ngIf="!hubService.isSessionReadOnly"
        class="chat-action-icon"
        [class.disabled-icon]="isNegativeFeedback(currentResponseItem)"
        [src]="
          isPositiveFeedback(currentResponseItem)
            ? '../../../assets/icons/svg/thumbs-up-filled.svg'
            : '../../../assets/icons/svg/thumbs-up.svg'
        "
        alt="Thumbs Up"
        height="18"
        width="18"
        matTooltipPosition="above"
        [matTooltipClass]="['header-saved-search-item-theme']"
        matTooltip="Positive Feedback"
        (click)="
          hubService.openKnowledgeChatCommentDialog(
            chatItem,
            currentResponseItem,
            true
          )
        "
        (keydown)="
          hubService.openKnowledgeChatCommentDialog(
            chatItem,
            currentResponseItem,
            true
          )
        "
      />
      <img
        *ngIf="!hubService.isSessionReadOnly"
        [class.disabled-icon]="isPositiveFeedback(currentResponseItem)"
        class="chat-action-icon"
        [src]="
          isNegativeFeedback(currentResponseItem)
            ? '../../../assets/icons/svg/thumbs-down-filled.svg'
            : '../../../assets/icons/svg/thumbs-down.svg'
        "
        alt="Thumbs Down"
        height="18"
        width="18"
        matTooltipPosition="above"
        [matTooltipClass]="['header-saved-search-item-theme']"
        matTooltip="Negative Feedback"
        (click)="
          hubService.openKnowledgeChatCommentDialog(
            chatItem,
            currentResponseItem,
            false
          )
        "
        (keydown)="
          hubService.openKnowledgeChatCommentDialog(
            chatItem,
            currentResponseItem,
            false
          )
        "
      />

      <img
        *ngIf="stats"
        class="chat-action-icon"
        src="../../../assets/icons/svg/chat-cost.svg"
        alt="Stats"
        height="20"
        width="20"
        matTooltipPosition="above"
        [matTooltipClass]="['header-saved-search-item-theme']"
        matTooltip="{{ helperService.getStatsTooltip(stats) }}"
      />
    </div>
  </div>
</ng-template>
